import React from 'react';
import { StatusChip } from '../ui-x';

/**
 * Record status. Delegates to ui-x StatusChip (reference rule 15: status is
 * always a StatusChip, re-labelled rather than recoloured).
 *
 * The strings below are mapped onto the six kinds semantically rather than by
 * copying the old colour groupings, which lumped "Closed" in with "Pending"
 * and painted every unrecognised value red.
 */
const KIND_BY_STATUS = {
  /* done / good */
  active: 'ready',
  open: 'ready',
  completed: 'ready',
  finished: 'ready',
  successful: 'ready',
  available: 'ready',
  verified: 'ready',
  approved: 'ready',
  accepted: 'ready',
  paid: 'ready',

  /* in flight */
  pending: 'progress',
  'on-going': 'progress',
  ongoing: 'progress',
  'in-progress': 'progress',
  processing: 'progress',
  unpaid: 'progress',

  /* awaiting a decision */
  interested: 'review',
  offered: 'review',
  submitted: 'review',
  'in-review': 'review',
  matched: 'review',

  /* not started */
  'to-start': 'draft',
  'not-started': 'draft',
  'not verified': 'draft',
  unverified: 'draft',
  draft: 'draft',
  new: 'draft',
  inactive: 'draft',

  /* finished, negatively or neutrally */
  closed: 'exited',
  expired: 'exited',
  ended: 'exited',
  withdrawn: 'exited',

  /* failed */
  rejected: 'suspended',
  declined: 'suspended',
  failed: 'suspended',
  suspended: 'suspended',
  cancelled: 'suspended',
  canceled: 'suspended',
  blocked: 'suspended',
};

export const statusKindFor = (label) =>
  KIND_BY_STATUS[String(label ?? '').trim().toLowerCase()] ?? 'draft';

const Status = ({ label, className }) => (
  <StatusChip
    status={statusKindFor(label)}
    label={label}
    className={className}
  />
);

export default Status;
